module.exports = __webpack_public_path__ + "img/basket.765e116e.svg";